import { __assign, __extends } from "tslib";
import * as React from 'react';
import { CodeComponent } from './components/code-component/code-component.comp';
import { CollapsibleComponent } from './components/collapsible-component/collapsible-component.comp';
import { HeadingComponent } from './components/heading-component/heading-component.comp';
import { HtmlComponent } from './components/html-component/html-component.comp';
import { IframeComponent } from './components/iframe-component/iframe-component.comp';
import { ImageComponent } from './components/image-component/image-component.comp';
import { InformativeComponent } from './components/informative-component/informative-component.comp';
import { LineComponent } from './components/line-component/line-component.comp';
import { MarkdownComponent } from './components/markdown-component/markdown-component.comp';
import { QuestionComponent } from './components/question-component/question-component.comp';
import { StepByStepComponent } from './components/step-by-step-component/step-by-step-component.comp';
import { TableComponent } from './components/table-component/table-component.comp';
import { TabsComponent } from './components/tabs-component/tabs-component.comp';
import { TextComponent } from './components/text-component/text-component.comp';
import { VideoComponent } from './components/video-component/video-component.comp';
import { namespacedClassnames } from '../utils/namespace-classes';
import { getLastListItemCount } from './helpers';
import { calcDirection } from '../utils/calc-direction';
// tslint:disable-next-line: max-line-length
/** @deprecated - use <ArticleViewer/> instead - https://github.com/wix-private/wix-answers/tree/master/answers-client/common/article-viewer */
var ComponentsViewer = /** @class */ (function (_super) {
    __extends(ComponentsViewer, _super);
    function ComponentsViewer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            textCompListOffsets: {}
        };
        _this.contentListUpdate = function () {
            var components = _this.props.components;
            var textCompListOffsets = components.reduce(function (acc, _, idx) {
                var _a;
                var listOffset = getLastListItemCount(components, idx);
                return __assign(__assign({}, acc), (_a = {}, _a[idx] = listOffset, _a));
            }, {});
            _this.setState({ textCompListOffsets: textCompListOffsets });
        };
        _this.renderArticleComponent = function (articleComponent, idx) {
            var renderedComponent = _this.renderComponent(articleComponent.type, articleComponent.value, idx);
            return _this.props.componentWrapper ? (_this.props.componentWrapper(renderedComponent, articleComponent)) : renderedComponent;
        };
        _this.mapFontConfigToCssVars = function () {
            var prefix = '--article-viewer';
            return _this.props.fontConfig ?
                Object.keys(_this.props.fontConfig).reduce(function (acc, key) {
                    acc["".concat(prefix, "-").concat(key)] = _this.props.fontConfig[key];
                    return acc;
                }, {}) :
                {};
        };
        _this.mapThemeToClassName = function () {
            switch (_this.props.theme) {
                case 'wix':
                    return 'wix-custom-style';
                default:
                    return '';
            }
        };
        return _this;
    }
    ComponentsViewer.prototype.componentDidMount = function () {
        var onLinkClick = this.props.onLinkClick;
        this.contentListUpdate();
        if (onLinkClick) {
            var linkElements = document.body.querySelectorAll('.components-viewer a');
            Array.from(linkElements).forEach(function (link) {
                var path = link.getAttribute('href') || '';
                link.addEventListener('click', function (e) { return onLinkClick(e, path); });
            });
        }
    };
    ComponentsViewer.prototype.componentDidUpdate = function (prevProps) {
        if (JSON.stringify(prevProps.components) !== JSON.stringify(this.props.components)) {
            this.contentListUpdate();
        }
    };
    ComponentsViewer.prototype.renderComponent = function (type, value, idx) {
        var _a, _b;
        var props = this.props;
        var listOffset = this.state.textCompListOffsets[idx] || 0;
        var direction = calcDirection(props.locale);
        switch (type) {
            case 'text':
                return React.createElement(TextComponent, { key: idx, value: value, listOffset: listOffset });
            case 'line':
                return React.createElement(LineComponent, { key: idx, value: value });
            case 'image':
                var maybeOnImgClick = props.onImgClick ? props.onImgClick.bind(this) : undefined;
                return React.createElement(ImageComponent, { key: idx, value: value, onImgClick: maybeOnImgClick });
            case 'heading':
                return React.createElement(HeadingComponent, { key: idx, value: value });
            case 'informative':
                return React.createElement(InformativeComponent, { key: idx, value: value, direction: direction });
            case 'video':
                return React.createElement(VideoComponent, { key: idx, value: value, direction: direction });
            case 'code':
                return React.createElement(CodeComponent, { key: idx, value: value });
            case 'html':
                return React.createElement(HtmlComponent, { key: idx, value: value });
            case 'collapsible':
                return React.createElement(CollapsibleComponent, { key: idx, value: value });
            case 'iframe':
                return React.createElement(IframeComponent, { key: idx, value: value });
            case 'step-by-step':
                return React.createElement(StepByStepComponent, { key: idx, value: value, locale: props.locale });
            case 'markdown':
                return React.createElement(MarkdownComponent, { key: idx, value: value });
            case 'table':
                return React.createElement(TableComponent, { key: idx, value: value, direction: direction });
            case 'tabs':
                return React.createElement(TabsComponent, { key: idx, value: value, locale: props.locale, direction: direction, onTabClick: (_a = props.tabsProps) === null || _a === void 0 ? void 0 : _a.onTabClick, selectedTabsOnLoad: (_b = props.tabsProps) === null || _b === void 0 ? void 0 : _b.selectedTabsOnLoad });
            case 'question':
                return React.createElement(QuestionComponent, { key: idx, value: value });
            default:
                throw new Error("Tried to render unknown component into view: ".concat(type));
        }
    };
    ComponentsViewer.prototype.render = function () {
        var components = this.props.components;
        var direction = calcDirection(this.props.locale);
        var classNames = namespacedClassnames('components-viewer', direction);
        return (React.createElement("div", { className: this.mapThemeToClassName() },
            React.createElement("div", { className: classNames, style: this.mapFontConfigToCssVars(), lang: this.props.locale }, components.map(this.renderArticleComponent))));
    };
    return ComponentsViewer;
}(React.Component));
export { ComponentsViewer };
//# sourceMappingURL=components-viewer.comp.js.map